import { cn } from '@/lib/cn';
import { Field, Textarea } from '@/components/ui/Field';

/**
 * Правилото на клиента: „всеки бус с повече от една заявка в курс, освен ако
 * е пълен". Изключенията са истински — спряла линия, няма друг товар по пътя —
 * и затова не са забрана, а причина, която остава записана в курса.
 */
export const SINGLE_ORDER_PRESETS = [
  'Спешно — спряла линия, тръгва веднага',
  'Няма друга заявка по направлението',
  'Клиентът плаща целия бус',
];

export function SingleOrderReasonField({
  value,
  onChange,
  loadNote,
}: {
  value: string;
  onChange: (value: string) => void;
  /** „30 % тегло, 12 % обем" — колко е пълен бусът. */
  loadNote?: string;
}) {
  return (
    <div className="rounded-lg border border-warn/40 bg-warn-soft/40 p-3">
      <p className="text-xs text-warn">
        Бусът тръгва с една заявка и не е пълен{loadNote ? ` (${loadNote})` : ''}. Добавете още заявки по
        пътя или напишете защо тръгва така — причината остава в курса.
      </p>
      <div className="mt-2 flex flex-wrap gap-1.5">
        {SINGLE_ORDER_PRESETS.map((preset) => (
          <button
            key={preset}
            type="button"
            onClick={() => onChange(preset)}
            className={cn(
              'rounded-full border px-2 py-0.5 text-[11px] transition-colors',
              value === preset
                ? 'border-accent bg-accent-soft text-accent'
                : 'border-line-strong text-ink-dim hover:border-accent/60 hover:text-ink',
            )}
          >
            {preset}
          </button>
        ))}
      </div>
      <Field label="Причина" className="mt-2">
        <Textarea rows={2} value={value} onChange={(e) => onChange(e.target.value)} />
      </Field>
    </div>
  );
}
